<template>
<div>

<!-- Modal -->

  <div class="modal modal-mask" id="stockHistory" style="display: block">
  <div class="modal-dialog modal-dialog-scrollable modal-xl">

    <div class="modal-content">
      <div class="modal-header bg-warning">
        <h4 class="modal-title" id="staticBackdropLabel">
          <i class="fas fa-folder-open mr-2"></i>
          <strong>LISTA DOCUMENTI DI ACQUISTO</strong> </h4>
        
      </div>
      <div class="modal-body">
        <spinner v-if="spinner" v-bind:spinner='spinner'></spinner>
        
        <div v-else class="table-wrapper-scroll-y my-custom-scrollbar">  
        <table class="table table-bordered table-hover table-sm">
        <thead>
            <tr>
            <th></th>  
            <th scope="col">#</th>      
            <th scope="col">STORE</th>    
            <th>COLLEZIONE</th>
            <th scope="col">STAGIONE</th>
            <th scope="col">DATA MOV.</th>
            
            <th scope="col">DOCUMENTO</th>
            <th scope="col">NUMERO</th>
            <th scope="col">DATA</th>
            
            
            <th scope="col">QTA</th>
            <th scope="col">TOTALE</th>
            </tr>
        </thead>
        <tbody>
            <tr  @click=setItem(item) class="pointer"   v-for="(item,index) in items" :key="index">
                <td>
                  <i v-if="item.selected" :style="{color:'red'}" class="fas fa-thumbtack" aria-hidden="true"></i>
                </td>
                <td class="text-nowrap_">{{index+1}}</td>
                <td class="text-nowrap">{{item.store}}</td>
                <td class="text-nowrap">{{ item.collection }}</td>
                <td class="text-nowrap">{{item.data}}</td>
                <td>{{item.create_at}}</td>
                
                <td class="text-nowrap">{{item.description}}</td>
                <td class="text-nowrap">{{item.number}}</td>
                <td>{{item.date}}</td>
                
                
                <td class="text-right">{{item.total1}} </td>
                <td class="text-right">{{fmt1(item.total3)}}</td>
                
            </tr>
        </tbody>
        </table>
        </div>


        <span class="ml-4"><strong>CLICK SELEZIONA DOCUMENTO</strong></span>
      </div>

      <div class="modal-footer">

        
        <button type="button"  @click="$emit('close')" class="btn btn-primary" data-dismiss="modal">CHIUDI</button>
        
      </div>
    </div>
  </div>
</div>

</div>
</template>

<script>


import spinner            from '@/components/common/Spinner.vue';
import fmt                from '@/components/mixins/fmt'
import api                from '@/api'
import { mapGetters }     from 'vuex';
  export default {
  mixins     : [fmt],
  props      : ['props'],
  components: {
     spinner
   
  },   
    data () {
      return {
        
          items : [],
          spinner : false     
      
      }
    },
    computed :{
    ...mapGetters(['company']),
   
  },

    created () 
      {
       // console.log(this.props)
        this.getData()
      },
    methods: 
    {

    setItem(item)  
    {
      const selectedItems = []
      item.selected = !item.selected
      
      this.items.forEach(item=>
      {

        if(item.selected)
        {
          selectedItems.push({'stockMovementId':item.stockMovementId})
        }
        

      })
      this.$emit('update',selectedItems)
            
    },
      async getData()
      {
        this.spinner = true
        const data   = this.props
        const sp     = {'sp':'spSupplierCollectionDocuments'} 
        const json   = Object.assign(data, sp)  
        
        await api.post(json).then(res => {
          if(res.status==200)
            {
             this.items = res.data.recordsets[0]
             this.items.forEach(item => {
              this.$set(item, 'selected', false)              
              
             }); 

             this.props.selectedDocuments.items.forEach(d => {
              this.items.forEach(item => {
                if(d.stockMovementId == item.stockMovementId)
                {
                  item.selected = true
                }
              })
             })

             
             
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });

      },
          
    }
  }
</script>
<style scoped>

.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}

  h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}


.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;

}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #7ea2e9;
    color        : rgb(20, 1, 1);   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.my-custom-scrollbar {
    position  : relative;
    height    : 400px;
    overflow  : auto;
    }
.table-wrapper-scroll-y {
    display   : block;
  }
  .modal-xl {
   
   
   max-width: 50% !important;
   
}
</style>
